import React, { useState } from 'react';

import { InputLabel, Stack } from 'components';
import { Text } from 'iconsax-react';

import { RawSliderInput } from './RawSliderInput';

type Props = {
  label: string;
  defaultValue: number;
  onChange: (data: number) => void;
};

export const FontSizeInput: React.FC<Props> = ({
  label,
  defaultValue,
  onChange,
}) => {
  const [value, setValue] = useState(defaultValue);
  const handleChange = (value: number) => {
    setValue(value);
    onChange(value);
  };
  return (
    <Stack spacing={1} alignItems="flex-start">
      <InputLabel shrink>{label}</InputLabel>
      <RawSliderInput
        iconLabel={<Text variant="TwoTone" size="16" />}
        value={value}
        setValue={handleChange}
        units="px"
        step={1}
        min={10}
        max={48}
      />
    </Stack>
  );
};
